import type { MaybeRefOrGetter } from 'vue';
import { computed, toValue } from 'vue';
import { fetchGxzzSiteByCompanyId } from '@/utils/business/siteGxzz.js';

function normalizeCompanyId(raw: unknown): string {
	if (raw == null || raw === '') return '';
	if (Array.isArray(raw)) return normalizeCompanyId(raw[0]);
	return String(raw).trim();
}

/**
 * 是否国械智造子站。SSR 由 `useAsyncData` 拉取并缓存，与首包水合一致。
 * 若页面已 `queryWebsiteByCompanyId`，可直接 `isGxzzFromWebsiteData(res.data)`，避免重复请求。
 */
export function useIsGxzzSite(companyId: MaybeRefOrGetter<string | number | null | undefined | string[]>) {
	const id = computed(() => normalizeCompanyId(toValue(companyId)));

	const { data } = useAsyncData(
		() => `gxzz-site:${id.value || 'none'}`,
		() => (id.value ? fetchGxzzSiteByCompanyId(id.value) : Promise.resolve(false)),
		{ server: true, watch: [id], default: () => false }
	);

	return computed(() => Boolean(data.value));
}
